import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../../../constants'

export const TitleRow = () => {
  return (
    <Root>
      <SubProjectCode>
        <span>Sub-Project Code</span>
      </SubProjectCode>
      <SaleGroup>
        <span>Sale Group</span>
      </SaleGroup>
      <Description>
        <span>Description</span>
      </Description>
      <DeliveryPlan>
        <span>Delivery Plan</span>
      </DeliveryPlan>
      <CreditTerm>
        <span>Credit Term</span>
      </CreditTerm>
      <Cost>
        <span>Costs</span>
      </Cost>
      <Price>
        <span>Prices</span>
      </Price>
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 25px;
  display: grid;
  grid-gap: 0 10px;
  grid-template-columns: 1fr 1fr 2fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: 25px;
  background: #616161;
  padding: 0 24px;
`

const SubProjectCode = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  span {
      font-family: ${FONTS.GOTHAM};
      font-size: ${FONTS.SMALL_SIZE};
      color: #FFFFFF;
  }
`

const SaleGroup = styled(SubProjectCode)``

const Description = styled(SubProjectCode)`
`

const DeliveryPlan = styled(SubProjectCode)`
`

const CreditTerm = styled(SubProjectCode)`
`

const Cost = styled(SubProjectCode)`
  justify-content: flex-end;
`

const Price = styled(SubProjectCode)`
  justify-content: flex-end;
`




// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/cost-planning/tab-pane-other-service/title-row.js